module.exports = __webpack_public_path__ + "assets/question-right.fc9699ca.svg";